import axiosInstance from "./axiosInstance";

const attendanceService = {
  fetchAll: async (filters) => {
    try {
      const response = await axiosInstance.get("/attendance/all", {
        params: filters,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default attendanceService;
